import { useCallback, useMemo, useState } from 'react';
import { CreateEventModal } from '../../pages';
import { Event } from '../../services';

interface EventEditArgs {
  event: Event;
}

export const useEventEdit = ({ event }: EventEditArgs) => {
  const [opened, setOpened] = useState(false);

  const eventEditHandler = useCallback(() => {
    setOpened(true);
  }, []);

  const eventEditModal = useMemo(() => {
    if (!opened) {
      return null;
    }

    return <CreateEventModal isOpened={opened} onClose={() => setOpened(false)} event={event} />;
  }, [event, opened]);

  return { eventEditModal, eventEditHandler };
};
